export const formatSalary = (salary: string, locale: string = navigator.language) => {
  const cleaned = salary.replace(/\s+/g, "");
  if (!cleaned.includes(".") && !cleaned.includes(",")) {
    return Number(cleaned).toLocaleString(locale);
  }
  return salary;
};
